import styled from 'styled-components'

export const THead = styled.thead`
  th.actions {
    text-align: center;
  }
`
